import type { LlmUsageCost } from "@/features/llm-usage/api/llm-usage.api";
import { formatMicrosAsUsd } from "./money";

// ─── Cost display ───────────────────────────────────────────────────
// Cost is only as complete as the rates behind it, and the tab has to say which
// of three situations it is in rather than printing a dollar figure and letting
// the reader assume it is the whole bill.

export interface CostDisplay {
  /** What the cell or stat shows. */
  text: string;
  /** Some of the tokens had no rate, so the figure is a floor, not the bill. */
  isPartial: boolean;
  /** Nothing here is priced, so there is no figure to show at all. */
  isUnpriced: boolean;
}

/**
 * A dash rather than `$0.00` when no rate covers the tokens. `$0.00` is a
 * claim — that these calls were free — and it is the wrong one; a model nobody
 * has priced yet is unknown, not free. `$0.00` is kept for the case it is true:
 * priced tokens whose rate really is zero.
 */
export function costDisplay(cost: LlmUsageCost, locale?: string): CostDisplay {
  const isUnpriced = cost.costMicros === 0 && cost.unpricedTokens > 0;

  return {
    text: isUnpriced ? "—" : formatMicrosAsUsd(cost.costMicros, locale),
    isPartial: cost.costMicros > 0 && cost.unpricedTokens > 0,
    isUnpriced,
  };
}
